import { API_URL as BASE_API_URL } from '@funnels/constants';

import { axios } from '../_common/axios';

const SHOULD_USE_MOCK_API = localStorage.getItem('_lendi_funnels_debug_use_mock_api') === 'true';

const fetch = (applicationId: string): Promise<any> => {
  if (SHOULD_USE_MOCK_API) {
    return Promise.resolve({ data: {} });
  }

  return axios
    .get(
      `${BASE_API_URL}/v1/package-selections/?filter[applicationId]=${applicationId}&include=package.funder&page[offset]=0&page[limit]=1&fields[funder]=name&fields=userType,package&fields[loan-package]=funder&filter[userType]=TEAM`
    )
    .then((res) => res.data);
};

const productSelectionsApi = { fetch };

export default productSelectionsApi;
